import { getItemFromCloudStorage } from "@tradingApp/helpers/getItemFromCloudStorage";

export async function webAppAuthTokensGet(): Promise<
  [string | null, string | null]
> {
  const [tokenAccess, tokenRefresh] = await Promise.all([
    getItemFromCloudStorage("accessToken"),
    getItemFromCloudStorage("refreshToken"),
  ]);

  return [tokenAccess || null, tokenRefresh || null];
}
